/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AliasCreate,
  AliasOut,
  PageProductOut,
  ProblemDetail,
  ProductCreate,
  ProductDetail,
  ProductOut,
  ProductUpdate,
  ProductsListProductsParams,
  ProductsSearchProductsParams,
  SearchHit
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Список товаров
 */
export const productsListProducts = (
    params?: ProductsListProductsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageProductOut>(
      {url: `/api/v1/products`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getProductsListProductsQueryKey = (params?: ProductsListProductsParams,) => {
    return [
    `/api/v1/products`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProductsListProductsQueryOptions = <TData = Awaited<ReturnType<typeof productsListProducts>>, TError = ErrorType<ProblemDetail>>(params?: ProductsListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsListProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsListProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsListProducts>>> = ({ signal }) => productsListProducts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsListProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductsListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof productsListProducts>>>
export type ProductsListProductsQueryError = ErrorType<ProblemDetail>


export function useProductsListProducts<TData = Awaited<ReturnType<typeof productsListProducts>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  ProductsListProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsListProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsListProducts>>,
          TError,
          Awaited<ReturnType<typeof productsListProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductsListProducts<TData = Awaited<ReturnType<typeof productsListProducts>>, TError = ErrorType<ProblemDetail>>(
 params?: ProductsListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsListProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsListProducts>>,
          TError,
          Awaited<ReturnType<typeof productsListProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductsListProducts<TData = Awaited<ReturnType<typeof productsListProducts>>, TError = ErrorType<ProblemDetail>>(
 params?: ProductsListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsListProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Список товаров
 */

export function useProductsListProducts<TData = Awaited<ReturnType<typeof productsListProducts>>, TError = ErrorType<ProblemDetail>>(
 params?: ProductsListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsListProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductsListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Создать товар (при похожих названиях — 409 с кандидатами, см. confirm_new)
 */
export const productsCreateProduct = (
    productCreate: BodyType<ProductCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ProductOut>(
      {url: `/api/v1/products`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getProductsCreateProductMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsCreateProduct>>, TError,{data: BodyType<ProductCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof productsCreateProduct>>, TError,{data: BodyType<ProductCreate>}, TContext> => {

const mutationKey = ['productsCreateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsCreateProduct>>, {data: BodyType<ProductCreate>}> = (props) => {
          const {data} = props ?? {};

          return  productsCreateProduct(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsCreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof productsCreateProduct>>>
    export type ProductsCreateProductMutationBody = BodyType<ProductCreate>
    export type ProductsCreateProductMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Создать товар (при похожих названиях — 409 с кандидатами, см. confirm_new)
 */
export const useProductsCreateProduct = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsCreateProduct>>, TError,{data: BodyType<ProductCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsCreateProduct>>,
        TError,
        {data: BodyType<ProductCreate>},
        TContext
      > => {

      const mutationOptions = getProductsCreateProductMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Поиск для автокомплита (название и алиасы, с опечатками)
 */
export const productsSearchProducts = (
    params: ProductsSearchProductsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<SearchHit[]>(
      {url: `/api/v1/products/search`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getProductsSearchProductsQueryKey = (params?: ProductsSearchProductsParams,) => {
    return [
    `/api/v1/products/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProductsSearchProductsQueryOptions = <TData = Awaited<ReturnType<typeof productsSearchProducts>>, TError = ErrorType<ProblemDetail>>(params: ProductsSearchProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsSearchProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsSearchProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsSearchProducts>>> = ({ signal }) => productsSearchProducts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsSearchProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductsSearchProductsQueryResult = NonNullable<Awaited<ReturnType<typeof productsSearchProducts>>>
export type ProductsSearchProductsQueryError = ErrorType<ProblemDetail>


export function useProductsSearchProducts<TData = Awaited<ReturnType<typeof productsSearchProducts>>, TError = ErrorType<ProblemDetail>>(
 params: ProductsSearchProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsSearchProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsSearchProducts>>,
          TError,
          Awaited<ReturnType<typeof productsSearchProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductsSearchProducts<TData = Awaited<ReturnType<typeof productsSearchProducts>>, TError = ErrorType<ProblemDetail>>(
 params: ProductsSearchProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsSearchProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsSearchProducts>>,
          TError,
          Awaited<ReturnType<typeof productsSearchProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductsSearchProducts<TData = Awaited<ReturnType<typeof productsSearchProducts>>, TError = ErrorType<ProblemDetail>>(
 params: ProductsSearchProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsSearchProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Поиск для автокомплита (название и алиасы, с опечатками)
 */

export function useProductsSearchProducts<TData = Awaited<ReturnType<typeof productsSearchProducts>>, TError = ErrorType<ProblemDetail>>(
 params: ProductsSearchProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsSearchProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductsSearchProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get Product
 */
export const productsGetProduct = (
    productId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ProductDetail>(
      {url: `/api/v1/products/${productId}`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getProductsGetProductQueryKey = (productId?: number,) => {
    return [
    `/api/v1/products/${productId}`
    ] as const;
    }

    
export const getProductsGetProductQueryOptions = <TData = Awaited<ReturnType<typeof productsGetProduct>>, TError = ErrorType<ProblemDetail>>(productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsGetProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsGetProductQueryKey(productId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productsGetProduct>>> = ({ signal }) => productsGetProduct(productId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productsGetProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductsGetProductQueryResult = NonNullable<Awaited<ReturnType<typeof productsGetProduct>>>
export type ProductsGetProductQueryError = ErrorType<ProblemDetail>


export function useProductsGetProduct<TData = Awaited<ReturnType<typeof productsGetProduct>>, TError = ErrorType<ProblemDetail>>(
 productId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsGetProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsGetProduct>>,
          TError,
          Awaited<ReturnType<typeof productsGetProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductsGetProduct<TData = Awaited<ReturnType<typeof productsGetProduct>>, TError = ErrorType<ProblemDetail>>(
 productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsGetProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productsGetProduct>>,
          TError,
          Awaited<ReturnType<typeof productsGetProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProductsGetProduct<TData = Awaited<ReturnType<typeof productsGetProduct>>, TError = ErrorType<ProblemDetail>>(
 productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsGetProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Product
 */

export function useProductsGetProduct<TData = Awaited<ReturnType<typeof productsGetProduct>>, TError = ErrorType<ProblemDetail>>(
 productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productsGetProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProductsGetProductQueryOptions(productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update Product
 */
export const productsUpdateProduct = (
    productId: number,
    productUpdate: BodyType<ProductUpdate>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<ProductOut>(
      {url: `/api/v1/products/${productId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productUpdate
    },
      options);
    }
  


export const getProductsUpdateProductMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsUpdateProduct>>, TError,{productId: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof productsUpdateProduct>>, TError,{productId: number;data: BodyType<ProductUpdate>}, TContext> => {

const mutationKey = ['productsUpdateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsUpdateProduct>>, {productId: number;data: BodyType<ProductUpdate>}> = (props) => {
          const {productId,data} = props ?? {};

          return  productsUpdateProduct(productId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsUpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof productsUpdateProduct>>>
    export type ProductsUpdateProductMutationBody = BodyType<ProductUpdate>
    export type ProductsUpdateProductMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Update Product
 */
export const useProductsUpdateProduct = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsUpdateProduct>>, TError,{productId: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsUpdateProduct>>,
        TError,
        {productId: number;data: BodyType<ProductUpdate>},
        TContext
      > => {

      const mutationOptions = getProductsUpdateProductMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Add Alias
 */
export const productsAddAlias = (
    productId: number,
    aliasCreate: BodyType<AliasCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<AliasOut>(
      {url: `/api/v1/products/${productId}/aliases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aliasCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getProductsAddAliasMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsAddAlias>>, TError,{productId: number;data: BodyType<AliasCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof productsAddAlias>>, TError,{productId: number;data: BodyType<AliasCreate>}, TContext> => {

const mutationKey = ['productsAddAlias'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsAddAlias>>, {productId: number;data: BodyType<AliasCreate>}> = (props) => {
          const {productId,data} = props ?? {};

          return  productsAddAlias(productId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsAddAliasMutationResult = NonNullable<Awaited<ReturnType<typeof productsAddAlias>>>
    export type ProductsAddAliasMutationBody = BodyType<AliasCreate>
    export type ProductsAddAliasMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Add Alias
 */
export const useProductsAddAlias = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsAddAlias>>, TError,{productId: number;data: BodyType<AliasCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsAddAlias>>,
        TError,
        {productId: number;data: BodyType<AliasCreate>},
        TContext
      > => {

      const mutationOptions = getProductsAddAliasMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete Alias
 */
export const productsDeleteAlias = (
    productId: number,
    aliasId: number,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<void>(
      {url: `/api/v1/products/${productId}/aliases/${aliasId}`, method: 'DELETE'
    },
      options);
    }
  


export const getProductsDeleteAliasMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsDeleteAlias>>, TError,{productId: number;aliasId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof productsDeleteAlias>>, TError,{productId: number;aliasId: number}, TContext> => {

const mutationKey = ['productsDeleteAlias'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsDeleteAlias>>, {productId: number;aliasId: number}> = (props) => {
          const {productId,aliasId} = props ?? {};

          return  productsDeleteAlias(productId,aliasId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsDeleteAliasMutationResult = NonNullable<Awaited<ReturnType<typeof productsDeleteAlias>>>
    
    export type ProductsDeleteAliasMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Delete Alias
 */
export const useProductsDeleteAlias = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsDeleteAlias>>, TError,{productId: number;aliasId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsDeleteAlias>>,
        TError,
        {productId: number;aliasId: number},
        TContext
      > => {

      const mutationOptions = getProductsDeleteAliasMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    